<template>
    <div class="gotop">
        <a href="javascript:;" id="btn_gotop" class="btn_gotop" @click="scrollTop">
            <img src="@/assets/resource/images/com/gotop.png" alt="맨위로">
        </a>
    </div>
</template>

<script>
export default{
    props: {
        gotopSection: Number
    },
    methods: {
        scrollTop(){
            scrollTo({top: 0, behavior: 'smooth'});
            if(this.gotopSection == 0){
                this.$parent.gotopSectionZero();
            }
        },
        goTop(){
            var gotop = document.querySelector('.gotop');
            var target = document.querySelector('.footer');
            var targetHei = target.offsetHeight;
            var bodyHei = document.body.scrollHeight;
            var scrollHei = document.documentElement.clientHeight;
            if(gotop){
                document.addEventListener('scroll', () => {
                    if(bodyHei - scrollHei - targetHei < window.scrollY){
                        gotop.classList.add('on')
                    }else{
                        gotop.classList.remove('on')
                    }
                });
            }
        },
    },
    mounted() {
        document.addEventListener('scroll', () => {
            this.goTop();
        })   
    }
}
</script>